import { type Squishy } from './squishy';
import {
  SQUISHY_ID,
  RARITY,
} from './constants';

export const squishies = [
  // common
  {
    id: SQUISHY_ID.DEFAULT,
    name: 'Ickle Squish',
    rarity: RARITY.COMMON,
    file: 'default.webp',
  },
  {
    id: SQUISHY_ID.COOKIE,
    name: 'Cookie',
    rarity: RARITY.COMMON,
    file: 'cookie.webp',
  },
  {
    id: SQUISHY_ID.COWBOY,
    name: 'Cowboy',
    rarity: RARITY.COMMON,
    file: 'cowboy.webp',
  },
  {
    id: SQUISHY_ID.DIVING,
    name: 'Diving',
    rarity: RARITY.COMMON,
    file: 'diving.webp',
  },
  {
    id: SQUISHY_ID.FARMER,
    name: 'Farmer',
    rarity: RARITY.COMMON,
    file: 'farmer.webp',
  },
  {
    id: SQUISHY_ID.FROG,
    name: 'Frog',
    rarity: RARITY.COMMON,
    file: 'frog.webp',
  },
  {
    id: SQUISHY_ID.SLEEPIES,
    name: 'Sleepies',
    rarity: RARITY.COMMON,
    file: 'sleepies.webp',
  },
  {
    id: SQUISHY_ID.CANDY,
    name: 'Candy',
    rarity: RARITY.COMMON,
    file: 'candy.webp',
  },
  {
    id: SQUISHY_ID.SILVER,
    name: 'Silver',
    rarity: RARITY.COMMON,
    file: 'silver.webp',
  },
  {
    id: SQUISHY_ID.DIAMOND,
    name: 'Diamond',
    rarity: RARITY.COMMON,
    file: 'diamond.webp',
  },
  // uncommon
  {
    id: SQUISHY_ID.BEAR,
    name: 'Bear',
    rarity: RARITY.UNCOMMON,
    file: 'bear.webp',
  },
  {
    id: SQUISHY_ID.ELEPHANT,
    name: 'Elephant',
    rarity: RARITY.UNCOMMON,
    file: 'elephant.webp',
  },
  {
    id: SQUISHY_ID.GENIE,
    name: 'Genie',
    rarity: RARITY.UNCOMMON,
    file: 'genie.webp',
  },
  {
    id: SQUISHY_ID.RAINBOW,
    name: 'Rainbow',
    rarity: RARITY.UNCOMMON,
    file: 'rainbow.webp',
  },
  {
    id: SQUISHY_ID.SPACE,
    name: 'Space',
    rarity: RARITY.UNCOMMON,
    file: 'space.webp',
  },
  {
    id: SQUISHY_ID.SPLISH_SPLASH,
    name: 'Splish Splash',
    rarity: RARITY.UNCOMMON,
    file: 'splish-splash.webp',
  },
  {
    id: SQUISHY_ID.SUPER,
    name: 'Super',
    rarity: RARITY.UNCOMMON,
    file: 'super.webp',
  },
  {
    id: SQUISHY_ID.VAMPIRE,
    name: 'Vampire',
    rarity: RARITY.UNCOMMON,
    file: 'vampire.webp',
  },
  {
    id: SQUISHY_ID.LEOPARD,
    name: 'Leopard',
    rarity: RARITY.UNCOMMON,
    file: 'leopard.webp',
  },
  {
    id: SQUISHY_ID.GOLD,
    name: 'Gold',
    rarity: RARITY.UNCOMMON,
    file: 'gold.webp',
  },
  {
    id: SQUISHY_ID.EMERALD,
    name: 'Emerald',
    rarity: RARITY.UNCOMMON,
    file: 'emerald.webp',
  },
  // rare
  {
    id: SQUISHY_ID.BOO,
    name: 'Boo',
    rarity: RARITY.RARE,
    file: 'boo.webp',
  },
  {
    id: SQUISHY_ID.DINO,
    name: 'Dino',
    rarity: RARITY.RARE,
    file: 'dino.webp',
  },
  {
    id: SQUISHY_ID.DOGGO,
    name: 'Doggo',
    rarity: RARITY.RARE,
    file: 'doggo.webp',
  },  
  {
    id: SQUISHY_ID.KITTY,
    name: 'Kitty',
    rarity: RARITY.RARE,
    file: 'kitty.webp',
  },
  {
    id: SQUISHY_ID.KNIGHT,
    name: 'Knight',
    rarity: RARITY.RARE,
    file: 'knight.webp',
  },
  {
    id: SQUISHY_ID.REAPER,
    name: 'Reaper',
    rarity: RARITY.RARE,
    file: 'reaper.webp',
  },
  {
    id: SQUISHY_ID.SPARKLY,
    name: 'Sparkly',
    rarity: RARITY.RARE,
    file: 'sparkly.webp',
  },
  {
    id: SQUISHY_ID.AXOLOTL,
    name: 'Axolotl',
    rarity: RARITY.RARE,
    file: 'axolotl.webp',
  },
  // epic
  {
    id: SQUISHY_ID.FRANKEN,
    name: 'Franken',
    rarity: RARITY.EPIC,
    file: 'franken.webp',
  },
  {
    id: SQUISHY_ID.LIDAL,
    name: 'Lidal Moonies',
    rarity: RARITY.EPIC,
    file: 'lidal.webp',
  },
  {
    id: SQUISHY_ID.PIKA,
    name: 'Pika',
    rarity: RARITY.EPIC,
    file: 'pika.webp',
  },
  {
    id: SQUISHY_ID.BEE,
    name: 'Bee',
    rarity: RARITY.EPIC,
    file: 'bee.webp',
  },
  {
    id: SQUISHY_ID.BUNNY,
    name: 'Bunny',
    rarity: RARITY.EPIC,
    file: 'bunny.webp',
  },
  {
    id: SQUISHY_ID.SPOOKY,
    name: 'Spooky',
    rarity: RARITY.EPIC,
    file: 'spooky.webp',
  },
  {
    id: SQUISHY_ID.SNOW_LEOPARD,
    name: 'Snow Leopard',
    rarity: RARITY.EPIC,
    file: 'snow-leopard.webp',
  },
  // legendary
  {
    id: SQUISHY_ID.RAVENCLAW,
    name: 'Ravenclaw',
    rarity: RARITY.LEGENDARY,
    file: 'ravenclaw.webp',
  },
  {
    id: SQUISHY_ID.SKELETON,
    name: 'Skeleton',
    rarity: RARITY.LEGENDARY,
    file: 'skeleton.webp',
  },
  {
    id: SQUISHY_ID.FAIRY,
    name: 'Fairy',
    rarity: RARITY.LEGENDARY,
    file: 'fairy.webp',
  },
  {
    id: SQUISHY_ID.UNICORN,
    name: 'Unicorn',
    rarity: RARITY.LEGENDARY,
    file: 'unicorn.webp',
  },
  {
    id: SQUISHY_ID.ANGEL,
    name: 'Angel',
    rarity: RARITY.LEGENDARY,
    file: 'angel.webp',
  },
  {
    id: SQUISHY_ID.DRAGON,
    name: 'Dragon',
    rarity: RARITY.LEGENDARY,
    file: 'dragon.webp',
  },
  // locked
  {
    id: SQUISHY_ID.AXIE,
    name: 'Axie',
    rarity: RARITY.LOCKED,
    file: 'axie.webp',
  },
  {
    id: SQUISHY_ID.KODA,
    name: 'Koda',
    rarity: RARITY.LOCKED,
    file: 'koda.webp',
  },  
  {
    id: SQUISHY_ID.CHEEKY,
    name: 'Cheeky',
    rarity: RARITY.LOCKED,
    file: 'cheeky.webp',
  },
  {
    id: SQUISHY_ID.BA_BA_BA_BA,
    name: 'Ba Ba Ba Ba',
    rarity: RARITY.LOCKED,
    file: 'ba-ba-ba-ba.webp',
  },
  {
    id: SQUISHY_ID.BIRTHDAY,
    name: 'Birthday',
    rarity: RARITY.LOCKED,
    file: 'birthday.webp',
  },
] as Squishy[];

export const squishiesById = new Map<SQUISHY_ID, Squishy>(
  squishies.map(squishy => [squishy.id, squishy]),
);

export const squishiesByRarity = squishies.reduce((acc, squishy) => {
  if (!acc.has(squishy.rarity)) acc.set(squishy.rarity, []);
  acc.get(squishy.rarity)!.push(squishy);
  return acc;
}, new Map<RARITY, Squishy[]>());